/***
 * @ngdoc directive
 * @name BB:bbDayList
 * @restrict AE
 * @scope true
 *
 * @description
 *
 * Next 5 week calendar with time selection
 *
 * <pre>
 * restrict: 'AE'
 * replace: true
 * scope: true
 * </pre>
 *ice}
 *///


angular.module('BBPublicBooking').directive('bbDayList', () => {
        return {
            restrict: 'A',
            replace: true,
            scope: true,
            controller: 'DayList'
        };
    }
);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/day-list/bb_day_list.directive.js